import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent {
  @Input() type: string = "payment";
  @Input() message: string = "";
  @Input() isShowButton: boolean = true;
  @Input() buttonText: string = "Close";
  /** Diwali crackers behind the popup while the sale is live (orders and subscriptions); a popup that is not a purchase turns it off */
  @Input() diwaliCelebration: boolean = true;
  @Output() isCloseButtonEvent: EventEmitter<any> = new EventEmitter();
  optionsBackdrop: AnimationOptions = {
    path: "/assets/data/successcelebration.json",
    loop: true,
    autoplay: true
  };  
  options: AnimationOptions = {
    path: "/assets/data/success.json",
    loop: true,
    autoplay: true
  };  
  constructor(public commonService: CommonService) {
    // this.closePopUpTimer();
  }

  get showDiwaliAnimation(): boolean {
    return this.diwaliCelebration && this.commonService.isSaleActive();
  }

  close(type: string = "") {
    this.commonService.closePopUp();
    if (type) {
      this.isCloseButtonEvent.emit("reload")
    }
  }

// closePopUpTimer() {
//   setTimeout(() => {
//     this.close();
//   }, 5000);
// } 

}
